require('bootstrap');

const frontSlider = document.getElementById('frontSlider');
$(frontSlider).slick({
    autoplay:true,
    speed: 600,
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplaySpeed: 4000,
    fade: true
});

const noticeWrapper = $('.notice-wrapper');
noticeWrapper.slick({
    vertical: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    verticalSwiping: true,
    autoplay: true,
    autoplaySpeed: 1500,
    infinite: true,
    arrows: false,
    dots: false
});

const noticeArrows = document.querySelector('.notice-switches');
noticeArrows.addEventListener('click', e => {
    let el = e.target;
    if (['svg', 'polyline'].indexOf(el.nodeName) > -1) {
        while (true) {
            el = el.parentNode;
            if (el.nodeName === 'A') {
                break;
            }
        }
    }

    if (el.classList && el.classList.contains('carousel-link')) {
        if (el.classList.contains('prev')) {
            noticeWrapper.slick('slickPrev');
        } else if (el.classList.contains('next')) {
            noticeWrapper.slick('slickNext');
        }
    }
});

const searchForm = document.getElementById('search-form');
searchForm.addEventListener('submit', e=>{
   e.preventDefault();
   e.target.search.setAttribute('placeholder', '준비 중...');
});

const gallery = document.querySelector('.gallery');
$(gallery).slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 600,
    infinite: true,
    dots: true,
    arrows: false
});
